module.exports = __webpack_public_path__ + "static/media/language.42c467c9.svg";